import { useSociete, useTiersService } from '@europrocurement/l2d-domain';
import {
    type PrescripteursApiGetListTiersTiersCollection0Request,
    type TiersTiersJsonldTiersReadTiersReadExpanded,
} from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { filtersToElasticQuery } from '@europrocurement/l2d-redux-utils';

export type PrescipteursJson = TiersTiersJsonldTiersReadTiersReadExpanded & Record<string, unknown>;

export type LitePrescripteurJson = {
    '@id'?: string;
    id?: number;
    isPrescripteur?: boolean;
    isSousclient?: boolean;
    raisonSociale: string;
    siren?: string;
    siret?: string;
};

const usePrescribers = () => {
    const { prescribersApi } = useTiersService();
    let searchPrescriberByRaisonSocialeTimeout: number | undefined;

    const xIdSociete = useSociete();

    const searchPrescriber = (term: string): Promise<LitePrescripteurJson[]> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchPrescriberByRaisonSocialeTimeout);

            const fields: Array<string> = ['raisonSociale', 'siren', 'siret'];
            const clauses = { isPrescripteur: true };
            const search = [];

            if (term) {
                search.push({
                    bool: {
                        should: [
                            {
                                query_string: {
                                    query: `**${term}**`,
                                    fields,
                                },
                            },
                        ],
                    },
                });
            }

            const requestParameters: PrescripteursApiGetListTiersTiersCollection0Request = {
                xIdSociete,
                search: filtersToElasticQuery(clauses, search),
            };
            searchPrescriberByRaisonSocialeTimeout = setTimeout(() => {
                prescribersApi
                    .getListTiersTiersCollection(requestParameters)
                    .then((res) => {
                        const results = res.data['hydra:member'];
                        const liteResults = results.map((tiers) => ({
                            id: tiers.id,
                            isPrescripteur: tiers.isPrescripteur,
                            isSousclient: tiers.isSousclient,
                            raisonSociale: tiers.raisonSociale,
                            siren: tiers.siren,
                            siret: tiers.siret,
                        }));
                        resolve(liteResults as LitePrescripteurJson[]);
                    })
                    .catch(() => reject());
            }, 300);
        });

    return { searchPrescriber };
};

export default usePrescribers;
